import type { CardProps } from './Card.types';
import './Card.scss';

export default function Card({
  variant = 'elevated', padding = 'md', className, children, ...rest
}: CardProps) {
  return (
    <div
      className={[
        'card',
        `card--${variant}`,
        `card--p-${padding}`,
        className || '',
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}
